import React, { useEffect, useState } from "react";
import { BsArrowLeft } from "react-icons/bs";
import { coins } from "../../../constants/constants";
import GetRates from "../../../components/utils/GetRates";
import { useUser } from "../../../context/user-context";
import useAuthAxios from "../../../utils/baseAxios";
import PortionAmount from "../../../components/PortionAmount";
import { BiMessageSquareAdd } from "react-icons/bi";
import ClipLoader from "react-spinners/ClipLoader";
import { useQuery, useMutation } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { API } from "../../../constants/api";
import { errorMessage } from "../../../utils/errorMessage";
import { useNavigate } from "react-router-dom";
import WithdrawPreview from "./WithdrawPreview";
import WithdrawSuccess from "./WithdrawSuccess";
import useUserAsset from "../../../hooks/useUserAssets";
import { formatAmount } from "../../../utils/formatTime";
import { FaCaretDown } from "react-icons/fa";
import { RiErrorWarningFill } from "react-icons/ri";

const WithdrawToBank = ({
  setOpenWithdraw,
  setOpenWithdrawBank,
  selectedCoinObjj,
}: any) => {
  const axiosInstance = useAuthAxios();

  const { userDetails, refetch } = useUser();
  const [selectedCoinObj, setSelectedCoinObj] = useState<any>(null);
  const [coinBalancee, setCoinBalancee] = useState<number | null>(null);
  const nairaCoinRate = GetRates(selectedCoinObj?.abbr?.toLowerCase());
  const walletBalances = userDetails?.user.deexWalletBalances;
  const [bankName, setBankName] = useState<string>("");
  const [openWithdrawPreview, setOpenWithdrawPreview] =
    useState<boolean>(false);
  const [openWithdrawSuccess, setOpenWithdrawSuccess] =
    useState<boolean>(false);
  const [bankNumber, setBankNumber] = useState<string>("");
  const navigate = useNavigate();

  const [openBank, setOpenBank] = useState<boolean>(false);

  const [bankId, setBankId] = useState<string>("");
  const [accountName, setAccountName] = useState<string>("");
  const [coinAmount, setCoinAmount] = useState<string>("");
  const [usdAmount, setUsdAmount] = useState<string>("");
  // const [inputCurrency, setInputCurrency] = useState<"USD" | "COIN">("USD");
  const [disabled, setDisabled] = useState<boolean>(false);
  const [loadingIndex, setLoadingIndex] = useState<number | null>(null);
  const handleCoinChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedAbbr = e.target.value;
    const selectedAbbrLC = e.target.value.toLowerCase();
    const coin = coins.find((coin: any) => coin.abbr === selectedAbbr);
    setSelectedCoinObj(coin);
    const coinBalance = walletBalances[selectedAbbrLC];

    if (coinBalance !== undefined) {
      setCoinBalancee(coinBalance);
      // Here, you can display the balance in the UI, like updating state
    } else {
    }
  };
  const { coinRates } = useUserAsset();

  const coinRate = coinRates[selectedCoinObj?.abbr] || 0;
  useEffect(() => {
    if (selectedCoinObjj) {
      setSelectedCoinObj(selectedCoinObjj); // Set pre-selected coin
      const selectedAbbr = selectedCoinObjj?.abbr;
      const selectedAbbrLC = selectedCoinObjj?.abbr.toLowerCase();
      const coin = coins.find((coin: any) => coin.abbr === selectedAbbr);
      setSelectedCoinObj(coin);
      const coinBalance = walletBalances[selectedAbbrLC];

      if (coinBalance !== undefined) {
        setCoinBalancee(coinBalance);
        // Here, you can display the balance in the UI, like updating state
      } else {
      }
    }
  }, [selectedCoinObjj]);

  useEffect(() => {
    setCoinAmount("");
    setUsdAmount("");
  }, [selectedCoinObj]);

  const isNumber = (str: any) => {
    if (str.trim() === "") {
      return false;
    }

    return !isNaN(str);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (isNumber(value)) {
      setUsdAmount(value);
      if (coinRate) {
        const coinEquivalent = Number(value) / coinRate;
        setCoinAmount(coinEquivalent.toFixed(8)); // show up to 8 decimals for crypto
      }
    } else {
      setCoinAmount("");
      setUsdAmount("");
    }
  };
  const getAllBanks = async () => {
    const response = await axiosInstance.get(API.getBanks);
    return response.data;
  };

  const { data: allBanks, error: error1 } = useQuery({
    queryKey: ["all-banks"],
    queryFn: getAllBanks,
    retry: 1,
  });

  const getAllOldBanks = async () => {
    const response = await axiosInstance.get(API.getBanksDeex);
    return response.data;
  };

  const { data: allOldBanks, error: error2 } = useQuery({
    queryKey: ["all-old-banks"],
    queryFn: getAllOldBanks,
    retry: 1,
  });

  useEffect(() => {
    if (error1) {
      const newError = error1 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
    if (error2) {
      const newError = error2 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
  }, [error1, error2]);
  const makeDefault = async ({ accountNumber, bankCode }: any) => {
    const response = await axiosInstance.put(API.makeDefaultBank(bankId), {
      accountNumber,
      bankCode,
    });
    return response.data;
  };

  const completeMakeDefault = useMutation({
    mutationFn: makeDefault,
    onSuccess: (r) => {
      toast.success(r.message);
      refetch();
      setLoadingIndex(null);
      setTimeout(() => {
        setOpenBank(false);
      }, 1000);
    },
    onError: (e) => {
      // console.log(e);
      const err = e as any;
      toast.error(errorMessage(err?.message || err?.data?.message));
      setLoadingIndex(null);
    },
  });
  useEffect(() => {
    if (
      !selectedCoinObj?.abbr ||
      !bankNumber ||
      !coinRate ||
      coinBalancee == null ||
      coinBalancee <= 0 ||
      Number(usdAmount) <= 0 ||
      Number(usdAmount) > coinBalancee * coinRate ||
      (usdAmount !== "" && Number(usdAmount) > 0 && Number(usdAmount) < 10)
    ) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [
    coinAmount,
    usdAmount,
    bankNumber,
    selectedCoinObj?.abbr,
    coinRate,
    coinBalancee,
  ]);
  // console.log(coinRate);

  // console.log(usdAmount);
  const errorMessageText = (() => {
    if (
      usdAmount !== "" &&
      coinBalancee !== null &&
      Number(usdAmount) > coinBalancee * coinRate
    ) {
      return "Amount exceeds available balance";
    }

    if (usdAmount !== "" && Number(usdAmount) > 0 && Number(usdAmount) < 10) {
      return "Minimum withdrawal amount is $10";
    }

    return "";
  })();

  const resolveBankName = (bank: any) => {
    const matchedBank =
      allBanks?.data?.find(
        (allBank: any) => allBank.bankCode === bank.bankCode
      ) ||
      allOldBanks?.data?.find((newBank: any) => newBank.code === bank.bankCode);

    return (
      matchedBank?.bankName ||
      matchedBank?.name ||
      bank.bankName ||
      "Unknown Bank"
    );
  };

  useEffect(() => {
    if (
      userDetails?.user?.banks?.length > 0 &&
      allBanks?.data &&
      allOldBanks?.data
    ) {
      const defaultBank =
        userDetails?.user?.banks.find((bank: any) => bank.isDefault) ||
        userDetails?.user?.banks[0];

      setBankNumber(defaultBank.accountNumber);
      setBankName(resolveBankName(defaultBank));
      setAccountName(defaultBank.accountName);
    }
  }, [userDetails?.user?.banks, allBanks?.data, allOldBanks?.data]);

  // console.log(coinAmount);
  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              setOpenWithdrawBank(false);
              setOpenWithdraw(true);
            }}
            className="flex items-center gap-2 "
          >
            <BsArrowLeft className=" text-gray-800 dark:text-gray-200 text-[16px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-100  font-sora font-semibold text-[20px]">
            Withdraw
          </h4>
        </div>
        <div className="w-full mt-2">
          <div className="mt-6">
            <h4 className="text-[14px] font-bold text-gray-500 ">Amount</h4>

            <div className="w-full flex justify-between items-start border border-[#EAEAEA] dark:border-gray-700 shadow  rounded-[4px] p-3 mt-3">
              <div className="w-[50%]">
                <div className="w-full flex gap-2 justify-start items-center relative">
                  {selectedCoinObj?.abbr && (
                    <div className="flex justify-center items-center w-[22px] h-[22px] rounded-full">
                      <img
                        src={selectedCoinObj?.logo}
                        className="w-full h-full bg-cover"
                        alt=""
                      />
                    </div>
                  )}

                  <div
                    className={`relative ${
                      selectedCoinObj?.abbr ? "w-[60%]" : "w-[90%]"
                    }`}
                  >
                    <select
                      value={selectedCoinObj?.abbr || ""}
                      onChange={handleCoinChange}
                      className="outline-none w-full text-[14px] font-semibold text-gray-900 bg-transparent dark:text-gray-200 appearance-none pr-6"
                    >
                      <option value="" disabled>
                        Select a coin
                      </option>
                      {coins.map((coin: any, index: any) => (
                        <option key={index} value={coin.abbr}>
                          {coin.name}
                        </option>
                      ))}
                    </select>

                    {/* Custom Icon */}
                    <FaCaretDown className="absolute right-4 top-[55%] -translate-y-1/2 pointer-events-none text-gray-900 dark:text-gray-200 text-[20px]" />
                  </div>
                </div>
                <h4 className="text-[12px] text-gray-500 font-medium mt-2 pl-2">
                  {selectedCoinObj?.abbr}
                </h4>
              </div>
              <div className="w-[40%]">
                <div className="w-full flex justify-end items-center text-right gap-1 text-gray-900 dark:text-gray-200">
                  <span className="font-sora font-bold text-[18px]">$</span>
                  <input
                    type="number"
                    placeholder="0.00"
                    value={usdAmount}
                    autoFocus={true}
                    onChange={handleChange}
                    style={{ width: `${Math.max(usdAmount.length, 4)}ch` }}
                    className="text-right text-[18px] font-semibold bg-transparent outline-none"
                  />
                </div>
                <h4 className="text-right mt-1 text-[12px] font-medium text-gray-500 pr-2">
                  {coinAmount
                    ? `${formatAmount(Number(coinAmount))} ${
                        selectedCoinObj?.abbr
                      }`
                    : "0.000"}
                </h4>
              </div>
            </div>
            {errorMessageText && (
              <p className="text-red-500 text-[12px] mt-1 font-semibold italic">
                {errorMessageText}
              </p>
            )}
          </div>
          <div className="flex mt-2 justify-between font-semibold items-center">
            {coinBalancee != null ? (
              <h4 className="text-center  text-[11px]  text-[#BE6B0A]">
                Bal:{" "}
                <span className="">
                  {formatAmount(coinBalancee)} {selectedCoinObj?.abbr || ""}
                </span>
              </h4>
            ) : (
              <h4 className="text-center  text-[13px] font-semibold text-[#BE6B0A]">
                Bal: 0.00
              </h4>
            )}
            <PortionAmount
              setAmount={setUsdAmount}
              coinBalance={coinBalancee}
              coinRate={coinRate}
              onPortionSelect={(
                portion: any,
                rawCrypto: number,
                rawUsd: number
              ) => {
                setCoinAmount(rawCrypto.toFixed(8));
                setUsdAmount(formatAmount(Number(rawUsd ?? 0))); // usd if exists
              }}
            />
          </div>
          {/* <div className="w-full mt-2">
            <div className="flex justify-between gap-4 items-center">
              <div className="w-full mt-4">
                <h4 className="text-[14px] text-gray-800 dark:text-gray-300">
                  Amount
                </h4>
                <div className="h-[48px] mt-2 rounded-xl border border-gray-300 dark:border-gray-600 px-2 flex gap-1 justify-between items-center">
                  <input
                    type="number"
                    placeholder={`Amount in ${inputCurrency}`}
                    value={inputCurrency === "USD" ? usdAmount : coinAmount}
                    onChange={handleChange}
                    className="text-gray-600 w-10/12 dark:text-gray-300 bg-transparent text-[13px] text-left outline-none"
                  />
                  <h4
                    onClick={() =>
                      setInputCurrency((prev) =>
                        prev === "USD" ? "COIN" : "USD"
                      )
                    }
                    className="text-[13px] text-secondary_button font-bold cursor-pointer"
                  >
                    {inputCurrency === "USD"
                      ? "USD"
                      : selectedCoinObj?.abbr || ""}
                  </h4>
                </div>
              
                {inputCurrency === "USD" &&
                  usdAmount !== "" &&
                  coinBalancee !== null &&
                  Number(usdAmount) > coinBalancee * coinRate && (
                    <p className="text-red-500 text-[12px] mt-1">
                      Amount exceeds available balance
                    </p>
                  )}
              </div>
            </div>
            <div className="flex mt-2 justify-between font-semibold items-center">
              <h4 className="text-[11px] text-[#BE6B0A]">
                ~{" "}
                {inputCurrency === "USD"
                  ? `${coinAmount} ${selectedCoinObj?.abbr ?? ""}`
                  : `$${usdAmount}`}
              </h4>
              <PortionAmount
                setAmount={setCoinAmount}
                coinBalance={coinBalancee}
                onPortionSelect={() => {
                  if (inputCurrency !== "COIN") setInputCurrency("COIN");
                }}
              />
            </div>
            {usdAmount !== "" &&
              Number(usdAmount) > 0 &&
              Number(usdAmount) < 10 && (
                <h4 className="text-[11px] text-red-600 italic font-semibold text-left mt-2">
                  Minimum withdrawal amount is $10
                </h4>
              )}
          </div> */}

          <div className="mt-8 w-full relative">
            <h4 className="text-[14px] font-bold text-gray-500 ">
              Destination
            </h4>
            <div
              onClick={() => {
                setOpenBank((prev) => !prev);
              }}
              className="w-full cursor-pointer border border-[#EAEAEA] dark:border-gray-700 shadow  rounded-[4px] p-3 mt-3 flex justify-between items-center"
            >
              <div className="flex justify-start items-center gap-3">
                <div>
                  <h4 className="text-[13px] text-black font-semibold dark:text-gray-50">
                    {bankNumber} - {bankName}
                  </h4>
                  <h4 className="text-[11px] text-gray-500 font-medium mt-1 dark:text-gray-50">
                    {accountName}
                  </h4>
                </div>
              </div>
              <FaCaretDown className="text-[20px] text-gray-700 dark:text-gray-300" />
            </div>
            {openBank && (
              <div className="absolute z-50 rounded-xl w-full mt-2 p-3 h-[250px] border border-gray-200 dark:border-gray-600 dark:bg-gray-800 overflow-auto bg-white">
                {userDetails?.user?.banks.length >= 1 ? (
                  <div className="w-full">
                    {userDetails.user.banks
                      .sort((a: any, b: any) => b.isDefault - a.isDefault)
                      .map((bank: any, index: number) => {
                        const matchedBank =
                          allBanks?.data.find(
                            (allBank: any) => allBank.bankCode === bank.bankCode
                          ) ||
                          allOldBanks?.data.find(
                            (newBank: any) => newBank.code === bank.bankCode
                          );

                        return (
                          <div
                            key={index}
                            onClick={() => {
                              if (bank.isDefault) {
                                setBankNumber(bank.accountNumber);
                                setBankName(
                                  matchedBank?.bankName || matchedBank?.name
                                );
                                setAccountName(bank.accountName);
                                setOpenBank(false);
                              } else {
                                setBankId(bank._id);
                                setLoadingIndex(index);
                                setTimeout(() => {
                                  completeMakeDefault.mutate({
                                    accountNumber: bank.accountNumber,
                                    bankCode: bank.bankCode,
                                  });
                                  setBankNumber(bank.accountNumber);
                                  setBankName(
                                    matchedBank?.bankName || matchedBank?.name
                                  );
                                  setAccountName(bank.accountName);
                                }, 500);
                              }
                            }}
                            className={`w-full cursor-pointer flex justify-start items-center gap-4 p-4 ${
                              bank.isDefault
                                ? "border border-secondary_button rounded-xl"
                                : "border-b border-gray-200 dark:border-gray-600"
                            }`}
                          >
                            {loadingIndex === index ? (
                              <ClipLoader color="#5E91FF" size={20} />
                            ) : (
                              <div
                                className={`w-[20px] h-[20px] p-1 flex justify-center items-center rounded-full border ${
                                  bank.isDefault
                                    ? "border-secondary_button"
                                    : "bg-transparent border-[#505050]"
                                }`}
                              >
                                <div
                                  className={`w-full h-full rounded-full ${
                                    bank.isDefault
                                      ? "bg-secondary_button"
                                      : "bg-transparent"
                                  }`}
                                />
                              </div>
                            )}
                            <div>
                              <h4 className="text-[10px] font-bold text-gray-700 dark:text-gray-200">
                                {bank.accountName}
                              </h4>
                              <h4 className="text-gray-900 dark:text-gray-100 text-[14px]">
                                {bank.accountNumber} -{" "}
                                {matchedBank?.bankName ||
                                  matchedBank?.name ||
                                  "Unknown Bank"}
                              </h4>
                            </div>
                          </div>
                        );
                      })}
                  </div>
                ) : (
                  <button
                    onClick={() => navigate("/settings")}
                    className="p-3 text-[14px] mt-8 mds:mt-0 transition ease-out duration-300 rounded-xl bg-secondary_button text-white gap-4 flex justify-center items-center"
                  >
                    <h4>Add bank</h4>
                    <BiMessageSquareAdd className="text-2xl" />
                  </button>
                )}
              </div>
            )}
            <h4 className="text-[11px] text-[#BE6B0A] font-semibold text-center mt-6">
              1$ ~ ₦{nairaCoinRate ? nairaCoinRate : "--"}
            </h4>
          </div>
          <div className="flex justify-center items-start py-3  gap-4 px-4 bg-[#E8F3FC] dark:bg-[#9AD1F9] w-full  mt-6  rounded-lg">
            <div>
              <RiErrorWarningFill className="text-[30px] text-secondary_button" />
            </div>
            <div>
              <h4 className="text-[13px] mt-1">
                Payout above <span className="font-bold">5,000,000</span> Naira
                will be paid in batches.
              </h4>
            </div>
          </div>

          <button
            onClick={() => {
              // setOpenWithdrawBank(false);
              setOpenWithdrawPreview(true);
            }}
            disabled={disabled}
            className={
              disabled
                ? "mt-8 bg-gray-400 flex justify-center items-center text-gray-200 text-[15px] font-medium h-[48px] w-full rounded-xl"
                : "mt-8 bg-secondary_button flex justify-center items-center text-white text-[15px] font-medium h-[48px] w-full rounded-xl"
            }
          >
            Done
          </button>
        </div>
      </div>
      {openWithdrawPreview && (
        <WithdrawPreview
          setOpenWithdrawBank={setOpenWithdrawBank}
          setOpenWithdrawPreview={setOpenWithdrawPreview}
          setOpenWithdrawSuccess={setOpenWithdrawSuccess}
          amount={coinAmount}
          coin={selectedCoinObj}
          usdAmount={usdAmount}
        />
      )}
      {openWithdrawSuccess && (
        <WithdrawSuccess
          setOpenWithdrawSuccess={setOpenWithdrawSuccess}
          amount={coinAmount}
          coin={selectedCoinObj}
          setOpenWithdrawBank={setOpenWithdrawBank}
        />
      )}
    </div>
  );
};

export default WithdrawToBank;
